import { BeltSyllabus } from './types';

export const whiteBeltYellowTag: BeltSyllabus = {
  id: 'white-yellow',
  name: 'White Belt Yellow Tag',
  color: '#ffff00', // Yellow (simplified)
  theoryUnder13: [
    {
      title: 'Theory',
      items: [
        {
          question: 'What does Chon-Ji mean?',
          answer: 'Heaven and Earth'
        },
        {
          question: 'How many movements in Chon-Ji?',
          answer: '19'
        },
        {
          question: 'What is the diagram of Chon-Ji?',
          answer: '/images/chon-ji-diagram.png',
          isImage: true
        },
        {
          question: 'What is the second tenet of Taekwon-Do?',
          answer: 'Integrity'
        },
        {
          question: 'What does integrity mean?',
          answer: 'To be honest, to live to a moral code'
        },
        {
          question: 'Describe or point to the 3 sections of the body?',
          answer: [
            'High – the neck and head',
            'Middle – the belt to the neck',
            'Low – below the belt'
          ]
        }
      ]
    },
    {
      title: 'Korean Terms',
      items: [
        { question: 'High', answer: 'Nopundae' },
        { question: 'Middle', answer: 'Ka-un-dae' },
        { question: 'Low', answer: 'Najundae' },
        { question: 'L Stance', answer: 'Niunja Sogi' },
        { question: 'Strike', answer: 'Taerigi' },
        { question: 'Forefist', answer: 'Ap Joomok' },
        { question: 'Turning Kick', answer: 'Dollyo Chagi' },
        { question: 'Knifehand', answer: 'Sonkal' },
        { question: 'Inner Forearm', answer: 'An Palmok' },
        { question: 'Outer Forearm', answer: 'Bakat Palmok' }
      ]
    }
  ],
  theoryOver13: [
    {
      title: 'Theory',
      items: [
        {
          question: 'What does Chon-Ji mean?',
          answer: 'Chon-Ji means literally “The Heaven The Earth”. It is, in the Orient, interpreted as the creation of the world or the beginning of human history: therefore, it is the initial pattern played by the beginner. This pattern consists of two similar parts, one represents the Heaven and the other represents the Earth.'
        },
        {
          question: 'How many movements in Chon-Ji?',
          answer: '19'
        },
        {
          question: 'What is the diagram of Chon-Ji?',
          answer: '/images/chon-ji-diagram.png',
          isImage: true
        },
        {
          question: 'What is a Pattern?',
          answer: 'A Pattern (Tul) is a set of fundamental movements, both offensive and defensive, performed against an imaginary opponent.'
        },
        {
          question: 'What is an Obverse technique?',
          answer: 'An Obverse technique is one in which the attacking or blocking arm is on the same side as the leading leg.'
        },
        {
          question: 'What is a Reverse technique?',
          answer: 'A Reverse technique is one in which the attacking or blocking arm is on the opposite side to the leading leg.'
        },
        {
          question: 'What is the definition of “Leading Leg”?',
          answer: 'In a stance, the leading leg is the leg which carries the most weight. For stances that have equal weight distribution, (such as Walking Stance), the leading leg is the front leg. For symmetrical stances, (such as Sitting Stance), there is no leading leg.'
        }
      ]
    },
    {
      title: 'Korean Terms',
      items: [
        { question: 'L Stance', answer: 'Niunja Sogi' },
        { question: 'Fingertip', answer: 'Taerigi' }, // Note: Original file had "Fingertip" mapped to "Taerigi" (Strike). Keeping as is to match source, though seems mismatched. Wait, verify.
        { question: 'Front Snap Kick', answer: 'Ap Cha Busigi' },
        { question: 'Turning Kick', answer: 'Dollyo Chagi' },
        { question: 'Forefist Middle Punch', answer: 'Ap Joomok Ka-un-dae Jirugi' },
        { question: 'Inner Forearm Middle Block', answer: 'An Palmok Ka-un-dae Makgi' },
        { question: 'Outer Forearm Low Block', answer: 'Bakat Palmok Najundae Makgi' },
        { question: 'Outer Forearm High Block', answer: 'Bakat Palmok Nopundae Makgi' },
        { question: 'Outer Forearm Rising Block', answer: 'Bakat Palmok Chookyo Makgi' },
        { question: 'Twin Forearm Block', answer: 'Sang Palmok Makgi' },
        { question: 'Knifehand Side Strike', answer: 'Sonkal Yop Taerigi' },
        { question: 'Knifehand Guarding Block', answer: 'Sonkal Daebi Makgi' }
      ]
    }
  ],
  practical: [
    {
      title: 'Practical Elements',
      items: [
        {
          question: 'Sitting Stance, Two Middle Punches (Fast Motion)',
          answer: ['Right then Left X 5', 'Left then Right X 5'],
          note: 'Raise left hand to start then change hands after 5'
        },
        {
          question: 'Low Front Snap Kick, Walking Stance Middle Punch',
          answer: 'Forward X 4'
        },
        {
          question: 'Walking Stance Inner Forearm Middle Block, Reverse Middle Punch',
          answer: 'Backward X 4'
        },
        {
          question: 'Walking Stance Outer Forearm Low Block, Outer Forearm Rising Block (Continuous Motion)',
          answer: 'Forward X 4'
        },
        {
          question: 'L Stance Twin Forearm Block',
          answer: 'Backward X 4'
        },
        {
          question: 'L Stance Knifehand Side Strike',
          answer: 'Forward X 4'
        },
        {
          question: 'L Stance Knifehand Guarding Block',
          answer: 'Backward X 4'
        }
      ]
    },
    {
      title: 'Power',
      items: [
        {
          question: 'Turning Kick',
          answer: 'Target / Kick Shield'
        }
      ]
    },
    {
      title: 'Pattern',
      items: [
        {
          question: 'Saju Makgi',
          answer: ' '
        },
        {
          question: 'Chon-Ji',
          answer: ' '
        }
      ]
    },
    {
      title: 'Self Defence',
      items: [
        {
          question: 'Wrist Hold – Release and Push attacker away',
          answer: "Under 13’s"
        },
        {
          question: 'Single Lapel Grab - Release and / or Stun the attacker',
          answer: 'All Ages'
        },
        {
          question: 'Situational - Swinging Punch(es)',
          answer: 'All Ages'
        }
      ]
    },
    {
      title: 'Sparring',
      items: [
        {
          question: 'Free Sparring',
          answer: 'Movement, Kicks and Punches'
        }
      ]
    }
  ]
};
